require('./firebase_auth.js');
import vueLoader from './vue.js';

export default () => {
  const app = vueLoader();
  return app;
};
